import "./GestionFamiliasOcultas.scss";
import { ComunicacionAjax } from "../../../ts/api/comunicacion";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getSelectionCell, TypedTable } from "../../../components/TypedTable";
import { useCallback, useEffect, useMemo, useState } from "react";
import { createColumnHelper } from "@tanstack/react-table";
import { Loading, QueryError } from "../../../components/Loading/Loading";
import { notificacion, notificacionError } from "../../../components/Alerts";

export function GestionFamiliasOcultasPage() {
	const queryClient = useQueryClient();
	const { data, error, isPending } = useFamiliasOcultas();
	const [familiasOcultas, setFamiliasOcultas] = useState<Record<string, boolean>>({});

	useEffect(() => {
		if (!data) return;

		const famOcultas: Record<string, boolean> = {};

		data.familiasOcultas.forEach(id => { famOcultas[id] = true; });

		setFamiliasOcultas(famOcultas);
	}, [data]);

	const guardarFamilias = useCallback(() => {
		if (!data) return;

		const ocultas = Object.entries(familiasOcultas).filter(([_, v]) => v).map(([k, _]) => k);

		ComunicacionAjax.sendAjaxRequest("POST", "/api/v1/familiasOcultas", {
			familiasOcultas: ocultas,
		}).then(() => {
			void queryClient.invalidateQueries({ queryKey: ["familiasOcultas"] });
			notificacion("Familias guardadas correctamente");
		}).catch((err: unknown) => {
			console.error(err);
			if (err instanceof Error)
				notificacionError("Error al guardar las familias: " + err.message);
			else
				notificacionError("Error al guardar las familias");
		});
	}, [data, familiasOcultas, queryClient]);

	if (error) return <QueryError error={error} fallback="Error al cargar las familias ocultas" />;
	if (isPending) return <Loading />;

	return (
		<div id="content" className="content" >
			<title>Almacen | Familias Ocultas</title>

			<div>
				<h1 style={{ marginBottom: 0 }}> Familias Ocultas </h1>
				<TablaFamilias familias={data.familiasERP} ocultas={familiasOcultas} setOcultas={setFamiliasOcultas} />
			</div>

			<div style={{ marginTop: "20px", textAlign: "center" }}>
				<button className="btnPrimary" onClick={guardarFamilias} type="button" style={{ width: "75%" }}>
					Guardar
				</button>
			</div>
		</div>
	);
}




interface TablaFamiliasProps {
	readonly familias: Familia[];
	readonly ocultas: Record<string, boolean>;
	readonly setOcultas: Setter<Record<string, boolean>>;
}
function TablaFamilias(props: TablaFamiliasProps) {
	const columns = useMemo(() => {
		const columnHelper = createColumnHelper<Familia>();

		return [
			getSelectionCell(columnHelper),
			columnHelper.accessor("id", { header: "ID" }),
			columnHelper.accessor("descripcion", { header: "Descripcion" }),
		];
	}, []);

	return (
		<TypedTable
			className="dataTable display"
			data={props.familias}
			columns={columns}

			getRowId={row => row.id}
			selection={props.ocultas}
			setSelection={props.setOcultas}

			pagination
			globalSearch
		/>
	);
}


function useFamiliasOcultas() {
	return useQuery<FamiliasOcultas>({
		queryKey: ["familiasOcultas"],
		queryFn: () => {
			return ComunicacionAjax.sendAjaxRequest<FamiliasOcultas>("GET", "/api/v1/familiasOcultas");
		},
	});
}
interface FamiliasOcultas {
	familiasOcultas: string[];
	familiasERP: Familia[];
}

interface Familia {
	id: string;
	descripcion: string,
}
